// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o7-c";
export var backButton = "_o7-4";
export var backIcon = "_o7-5";
export var chevronShortcut = "_o7-6";
export var container = "_o7-1";
export var editor = "_o7-8";
export var editorWrapper = "_o7-7";
export var prefix = "_o7-2";
export var searchIcon = "_o7-3";
export var suffix = "_o7-9";
export var suffixContent = "_o7-a";
export var suffixText = "_o7-b";
export var wrapper = "_o7-0";